import Link from "next/link";
import { ScanLine } from "lucide-react";
import { cn } from "@/lib/utils";

export function Brand({ compact = false, className }: { compact?: boolean; className?: string }) {
  return (
    <Link href="/" className={cn("group inline-flex items-center gap-2.5", className)} aria-label="PhaseOne home">
      <span className="relative grid size-8 place-items-center rounded-full bg-primary text-primary-foreground shadow-[inset_0_0_0_1px_color-mix(in_oklch,var(--primary-foreground),transparent_84%)]">
        <ScanLine aria-hidden="true" />
        <span className="absolute -right-0.5 -bottom-0.5 size-2.5 rounded-full border-2 border-background bg-signal" />
      </span>
      {!compact && (
        <span className="font-heading text-[1.15rem] leading-none font-semibold tracking-[-0.025em]">
          Phase<span className="text-signal">One</span>
        </span>
      )}
    </Link>
  );
}

